import React, { useEffect } from 'react';

const TermsRedirectPage = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace('/p/terms-of-service');
    }
  }, []);

  return (
    <main style={{ minHeight: '60vh', padding: '96px 24px', background: '#030405', color: '#fff' }}>
      <h1>Redirecting to terms...</h1>
      <p>
        If you are not redirected automatically, visit{' '}
        <a href="/p/terms-of-service" style={{ color: '#ff5c18' }}>
          /p/terms-of-service
        </a>.
      </p>
    </main>
  );
};

export default TermsRedirectPage;
